import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductCollection } from 'src/models/DTO/products/productCollection';
import { Config } from '../../../infrastructure/config';


@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private searchForProductsURL : string = Config.api + "product";


  constructor(private httpClient: HttpClient) { }

  public getSearchResults(perPage: number, page: number, query: string) {
    const params = "?fields%5Bproducts%5D=id%2Cuuid%2Cname%2Corganisation_id%2Ccreated_at%2Cupdated_at%2Ccategory_id%2Cbrand_id%2Cmanufacturer_id%2Cstate&fields%5Bskus%5D=id%2Cproduct_id%2Cuuid%2Csku%2Cavailable_quantity%2Creserved_quantity&include=skus%2Corganisation%2Cpricing%2Cbrand%2Ccategory%2Cmanufacturer%2Cskus.options.option%2Coptions&append=total_available_quantity%2Ctotal_reserved_quantity&fields%5Borganisation%5D=id%2Cuuid%2Cname_in_latin%2Cnative_name&fields%5Bpricing%5D=id%2Cproduct_id%2Cuuid%2Cquantity_from%2Cquantity_to%2Cprice_per_piece&fields%5Bcategory%5D=id%2Cuuid%2Cname&fields%5Bskus.options%5D=id%2Cuuid%2Csku_id%2Coption_variation_id%2Cdisplay_value&fields%5Bskus.options.option%5D=id%2Cuuid%2Cdisplay_name&fields%5Boptions%5D=id%2Cuuid%2Cdisplay_name&q=" + query + "&filter%5Bstate%5D=ACTIVE&perPage=" + perPage + '&page=' + page;
    return this.httpClient.get<ProductCollection>(this.searchForProductsURL + params);
  }
}
